import React, { useEffect, useContext, useState } from 'react'
import { AppContext } from '../../../global'
import { useParams } from 'react-router-dom'
import * as actions from '../store/actions'
import './ReportDetails.css'
import { getReportExport } from '../services/api'
import { downloadFile } from '../../../global/services/download'
import Loading from '../../../components/Loading'
import ReportParamPanel from './ReportParamPanel'
import { ReportParam } from '../store/store'
import ParamPill from './ParamPill'
import { RequestState } from '../../types'
import ContentHeader from '../../../components/layout/ContentHeader'
import HeaderActions from '../../../components/layout/HeaderActions'
import HeaderTitle from '../../../components/layout/HeaderTitle'
import { useTranslation } from 'react-i18next'
import { Params } from '../../types'
import Content from '../../../components/layout/Content'
import ContentBody from '../../../components/layout/ContentBody'

function ReportDetails() {
  const { state, execute } = useContext(AppContext)
  const { id, partnerId } = useParams() as Params
  const { currentReport, reportHtml } = state.reports
  const [downloading, setDownloading] = useState(false)
  const [paramPanelOpen, setParamPanelOpen] = useState(false)
  const { t } = useTranslation(['reports', 'global'])

  function updateParams(params: ReportParam[]) {
    if (partnerId && currentReport.report) {
      execute(actions.updateParams(params))
    }
  }

  function runReport() {
    if (partnerId && currentReport.report) {
      setParamPanelOpen(false)
      execute(actions.runReport(partnerId, currentReport.report))
    }
  }

  async function exportReport(format: 'csv' | 'pdf') {
    if (partnerId && currentReport.report && !downloading) {
      setDownloading(true)
      const exportDetails = await getReportExport(partnerId, id, currentReport.report.params, format)
      await downloadFile(exportDetails.data.download)
      setDownloading(false)
    }
  }

  function loadReportDetails(partnerId: string) {
    execute(actions.loadReport(partnerId))
  }

  useEffect(() => {
    loadReportDetails(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (currentReport.report) {
      //this means we run the report when the page loads AND if the params change
      runReport()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentReport.report])

  if (currentReport.requestState === RequestState.Loading) {
    return (
      <Loading />
    )
  } else if (currentReport.requestState === RequestState.Error) {
    return (
      <div className="padding-m">{t('unable_to_load_details')}</div>
    )
  } else if (currentReport.report) {
    return (
      <>
        <ContentHeader>
          <HeaderTitle>
            <b>{currentReport.report.name}</b>
            <div id="param-pills">
              {currentReport.report.params.map(param => {
                return (
                  <ParamPill key={param.key} param={param} />
                )
              })}
            </div>
          </HeaderTitle>

          <HeaderActions>
            <div className="header-bar-button" id="filter-btn" onClick={() => setParamPanelOpen(!paramPanelOpen)}>
              <i className="fas fa-filter"></i> {t('filter')}
            </div>
            <div className="header-bar-button" id="filter-btn" onClick={() => exportReport('pdf')}>
              <i className="fas fa-share-square"></i> PDF
              </div>
            <div className="header-bar-button" id="filter-btn" onClick={() => exportReport('csv')}>
              <i className="fas fa-share-square"></i> CSV
              </div>
          </HeaderActions>

        </ContentHeader>

        {reportHtml.requestState === RequestState.Loading && (
          <Loading />
        )}

        {reportHtml.report !== undefined && (
          <ContentBody>
            {paramPanelOpen && (
              <ReportParamPanel initialParams={currentReport.report.params} updateParams={updateParams} />
            )}
            <Content>
              <div id="report-content">
                <div dangerouslySetInnerHTML={{ __html: reportHtml.report }} />
              </div>
            </Content>
          </ContentBody>
        )}
      </>
    )
  } else {
    return (
      <div className="padding-m">{t('unable_to_load_details')}</div>
    )
  }
}

export default ReportDetails
